export default "__VITE_ASSET__516852ea__"